import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    vsTableFeed: [],
    tableRowIndex: 0,
    selectedRows: {},
    currentFile: {
      serviceId: 0,
      serviceName: "",
      servicePrice: "",
      sessionQuantity: "",
      disCountIds: [],
      payments: [
        {
          type: 3,
          price: ""
        },
        {
          type: 5,
          price: ""
        },
        {
          type: 2,
          price: ""
        },
        {
          type: 4,
          price: ""
        }
      ]
    },
    currentDiscount: {
      id: 0,
      title: "",
      price: "",
      percentage: "",
      startDate: "",
      endDate: "",
      isActive: false
    },
    currentService: {
      id: 0,
      title: "",
      price: 0,
      sessionQuantity: 0
    },
    currentPerson: {
      id: 0,
      name: "",
      bigName: "",
      nationalCode: "",
      mobile: "",
      phone: "",
      reagent: "",
      image: "",
      address: "",
      fatherName: ""
    },
    currentSession: {
      customer: {
        name: "",
        bigName: "",
        fileNumber: ""
      },
      servicesList: [],
      discountsList: [],
      operatorsList: [],
      preselectedService: {},
      file: {
        payments: [
          {
            type: 3,
            price: ""
          },
          {
            type: 5,
            price: ""
          },
          {
            type: 2,
            price: ""
          },
          {
            type: 4,
            price: ""
          }
        ],
        sessionDate: "",
        persianSessionDate: "",
        sessionQuantity: 0
      }
    },
    currentUser: {
      id: 0,
      name: "",
      bigName: "",
      nationalCode: "",
      mobile: "",
      phone: "",
      userName: "",
      password: "",
      roleId: ""
    }
  },
  mutations: {
    REPLACE_ROW_IN_VS_TABLE_FEED: (state, rowAndKey) => {
      Vue.set(state.vsTableFeed, rowAndKey.key, rowAndKey.row);
    },
    REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED: state => {
      while (state.vsTableFeed.length > 0) {
        state.vsTableFeed.pop();
      }
    },
    RESET_VS_TABLE_FEED: (state, newValue) => {
      state.vsTableFeed = newValue;
    },
    ADD_ROW_TO_VS_TABLE_FEED: (state, row) => {
      state.vsTableFeed.push(row);
    },
    DELETE_ROW_FROM_VS_TABLE_FEED: (state, id) => {
      state.vsTableFeed = state.vsTableFeed.filter(x => {
        return x.id !== id;
      });
    },
    SET_SELECTED_ROW: (state, rowAndKey) => {
      state.selectedRows[rowAndKey.key] = rowAndKey.row;
    },
    SET_CURRENT_FILE: (state, file) => {
      state.currentFile = file;
    },
    SET_CURRENT_DISCOUNT: (state, discount) => {
      state.currentDiscount = discount;
    },
    SET_CURRENT_SERVICE: (state, service) => {
      state.currentService = service;
    },
    SET_CURRENT_PERSON: (state, person) => {
      state.currentPerson = person;
    },
    SET_CURRENT_SESSION: (state, session) => {
      state.currentSession = session;
    },
    SET_CURRENT_USER: (state, user) => {
      state.currentUser = user;
    },
    SET_Table_Row_Index: (state, index) => {
      state.tableRowIndex = index;
    }
  }
});
